export default "__VITE_ASSET__6247c200__"